// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanBalancesDto } from './IPlanBalancesDto';
import {
    IPlanBalancesDtoFromJSON,
    IPlanBalancesDtoFromJSONTyped,
    IPlanBalancesDtoToJSON,
    IPlanBalancesDtoToJSONTyped,
} from './IPlanBalancesDto';

/**
 * 
 * @export
 * @interface IPlanDetailDto
 */
export interface IPlanDetailDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanDetailDto
     */
    plan_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanDetailDto
     */
    plan_name: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanDetailDto
     */
    balance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IPlanDetailDto
     */
    plan_omnibus_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanDetailDto
     */
    plan_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanDetailDto
     */
    plan_type: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanDetailDto
     */
    funding_method?: IPlanDetailDtoFundingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanDetailDto
     */
    available_balance_type?: IPlanDetailDtoAvailableBalanceTypeEnum;
    /**
     * 
     * @type {IPlanBalancesDto}
     * @memberof IPlanDetailDto
     */
    balances?: IPlanBalancesDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDetailDto
     */
    is_plan_level_funding: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPlanDetailDtoFundingMethodEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IPlanDetailDtoAvailableBalanceTypeEnum {
    ACTUAL_BALANCE = 'ACTUAL_BALANCE',
    ELECTION_BASED = 'ELECTION_BASED'
}


/**
 * Check if a given object implements the IPlanDetailDto interface.
 */
export function instanceOfIPlanDetailDto(value: object): value is IPlanDetailDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('plan_name' in value) || value['plan_name'] === undefined) return false;
    if (!('plan_type' in value) || value['plan_type'] === undefined) return false;
    if (!('is_plan_level_funding' in value) || value['is_plan_level_funding'] === undefined) return false;
    return true;
}

export function IPlanDetailDtoFromJSON(json: any): IPlanDetailDto {
    return IPlanDetailDtoFromJSONTyped(json, false);
}

export function IPlanDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'],
        'plan_name': json['plan_name'],
        'balance': json['balance'] == null ? undefined : json['balance'],
        'plan_omnibus_account_id': json['plan_omnibus_account_id'] == null ? undefined : json['plan_omnibus_account_id'],
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_type': json['plan_type'],
        'funding_method': json['funding_method'] == null ? undefined : json['funding_method'],
        'available_balance_type': json['available_balance_type'] == null ? undefined : json['available_balance_type'],
        'balances': json['balances'] == null ? undefined : IPlanBalancesDtoFromJSON(json['balances']),
        'is_plan_level_funding': json['is_plan_level_funding'],
    };
}

export function IPlanDetailDtoToJSON(json: any): IPlanDetailDto {
    return IPlanDetailDtoToJSONTyped(json, false);
}

export function IPlanDetailDtoToJSONTyped(value?: IPlanDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'balance': value['balance'],
        'plan_omnibus_account_id': value['plan_omnibus_account_id'],
        'plan_year': value['plan_year'],
        'plan_type': value['plan_type'],
        'funding_method': value['funding_method'],
        'available_balance_type': value['available_balance_type'],
        'balances': IPlanBalancesDtoToJSON(value['balances']),
        'is_plan_level_funding': value['is_plan_level_funding'],
    };
}

